declare const require: {
  context(directory: string, useSubdirectories: boolean, regExp: RegExp): {
    keys(): string[];
    <T = string>(id: string): T;
  };
};

export type GalleryCategory = 'consultorio' | 'resultados';

export interface Photo {
  src: string;
  width: number;
  height: number;
  filename: string;
  category: GalleryCategory;
  alt: string;
}

const imageContext = require.context('./', false, /\.(png|jpe?g|webp|avif)$/i);

const formatAltText = (filename: string, category: GalleryCategory): string => {
  const cleanName = filename.replace(/\.(png|jpe?g|webp|avif)$/i, '').replace(/^[a-z]+-/i, '').replace(/[._-]+/g, ' ').trim();
  const label = category === 'consultorio' ? 'Consultorio DentalPuente' : 'Resultado dental DentalPuente';
  return cleanName ? `${label} - ${cleanName}` : label;
};

const photos: Photo[] = imageContext
  .keys()
  .sort((firstKey, secondKey) => firstKey.localeCompare(secondKey, 'es-MX', { numeric: true }))
  .map((key) => {
    const filename = key.replace('./', '');
    const category: GalleryCategory = filename.toLowerCase().startsWith('consultorio-') ? 'consultorio' : 'resultados';
    return { src: imageContext<string>(key), width: 4, height: 3, filename, category, alt: formatAltText(filename, category) };
  });

export default photos;
